export const TARGET_LABELS = {
    EVENT: "Event",
    TEAM: "Team",
    PLAYER: "Player",
    EVENT_PLAYER: "Event player",
    BANNER: "Banner",
};

const personName = (item) => `${item.firstName || ""} ${item.lastName || ""}`.trim() || item.email || item.playerId;

export const optionsForTargetType = (targetType, catalogs = {}) => {
    if (targetType === "EVENT") {
        return (catalogs.events || []).map((event) => ({
            id: event.eventId,
            label: event.eventName || event.eventId,
        })).filter((item) => item.id);
    }
    if (targetType === "TEAM") {
        return (catalogs.teams || []).map((team) => ({
            id: team.teamId,
            label: team.teamName || team.teamId,
        })).filter((item) => item.id);
    }
    if (targetType === "PLAYER") {
        return (catalogs.players || []).map((player) => ({
            id: player.playerId,
            label: personName(player),
        })).filter((item) => item.id);
    }
    if (targetType === "EVENT_PLAYER") {
        return (catalogs.eventPlayers || []).map((player) => ({
            id: player.eventPlayerId || player.playerId,
            label: personName(player),
        })).filter((item) => item.id);
    }
    if (targetType === "BANNER") {
        return (catalogs.banners || []).map((banner) => ({
            id: banner.id || banner.bannerId,
            label: banner.title || banner.id,
        })).filter((item) => item.id);
    }
    return [];
};

export const targetFieldLabel = (targetType) => TARGET_LABELS[targetType] || "Target";

export const humanEnum = (value) =>
    String(value || "")
        .toLowerCase()
        .split("_")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

export const dealLabel = (deal = {}, sponsors = []) => {
    const sponsor = sponsors.find((item) => (item.id || item.sponsorId) === (deal.sponsorId || deal.sponsor?.id));
    const name = sponsor?.name || deal.sponsorName || deal.sponsor?.name;
    const parts = [deal.tier, name].filter(Boolean);
    return parts.length ? parts.join(" · ") : (deal.id || deal.sponsorshipId || "Deal");
};
